import './Footer.css'

const Footer = () => (
  <footer className='footer'>
    <a
      href='https://i.pinimg.com/originals/2b/47/b6/2b47b6c0bca519ff0435805be9d00c7f.jpg'
      className='link footer__link'
    >
      hasta la vista
    </a>
  </footer>
)

export default Footer
